export default __webpack_public_path__ + "static/media/TreeEquivalent.b36b7b97.svg";